








import { Component, Vue } from 'vue-property-decorator';

/**
 * Dialog for when the currently selected profile is not available for the current project
 */
@Component({
    props: {
        /**
         * Should the dialog be shown
         */
        active: {
            type: Boolean
        }
    }
})
export default class ProfileNotAvailableDialog extends Vue {

}
